import ApiService from "./ApiService";
import ResponseKind from "../ResponseKind";
import GeneratorState from "../../GeneratorState";
import States from "../States";
import RequestKind from "../RequestKind";

export default function () {
    const apiUrl = process.env.VUE_APP_API_URL;
    const wsUrl = process.env.VUE_APP_WS_URL;
    const that = this;

    /**
     * Create API as a child of WS since token needs to be obtained first which is then used in obtaining a
     * WS promise
     */
    this.api = new ApiService();
    this.socketPromise = establishConn();

    let store = null;
    let router = null;

    this.setStore = newStore => {
        store = newStore;
        this.api.setStore(newStore);

        if (typeof window.WebSocket === "undefined" || ! window.WebSocket ) {
            store.commit("setError", "Looks like your browser doesn't support Websockets. Please try a newer" +
                        " browser. We're sorry about the inconvenience!")
        }
    };

    this.setRouter = newRouter => router = newRouter;


    function establishConn() {
        return that.api.tokenPromise.then(token => {
            return new Promise(function(resolve, reject) {
                const  socket = new WebSocket(`${wsUrl}/ws?token=${token}`);
                const wrapper = new WebsocketWrapper(token, socket);
                socket.onopen = function() {
                    resolve(wrapper);
                };

                socket.onerror = function (e) {
                 window.console.log("Websocket issue:", e);
                 window.console.log("Requesting token again..");
                 //that.api.reset();
                  establishConn().then(wrapper => resolve(wrapper));
                }
            })
        })
    }




    function WebsocketWrapper(token, socket) {
        const that = this;
        that.token = token;
        that.socket = socket;
        init();

        that.generate = generate;
        that.expectRegen = expectRegen;
        that.fetchResults = fetchResults;
        that.checkDomains = checkDomains;
        that.vote = vote;
        that.markSeen = markSeen;
        that.prePurchaseInfo = prePurchaseInfo;
        that.reqPaymentIntent = reqPaymentIntent;
        that.prepareForMoney = prepareForMoney;
        that.txnStatus = txnStatus;

        const ping = JSON.stringify({kind: RequestKind.PING, data: {ping: "ping"}});
        const pong = JSON.stringify({pong: "pong", kind: ResponseKind.PONG});

        let currentExpectedResponse = null;
        let onProgressUpdate = null;
        let onResultsReceived = null;
        let onVoteResult = null;
        let currentPrePurchaseHandler = null;
        let currentIntentHandler = null;
        let currentPrepareForMoneyHandler = null;
        let currentTxnStatusHandler = null;

        function init(){
            that.socket.onclose = onClose;
            that.socket.onmessage = onMsg;

            that.socket.onerror = e => {
                window.console.warn("Websocket Error:", e);
                store.commit("setError", "We're having trouble reaching the server. Please reach out to" +
                            " hi@naminus.com if this issue persists.");
            };
            that.socket.onopen = (e)  => {
                window.console.log("Connected!");
            };

            sendPing();
        }

        function getProgressHandler(state, router, onProgress, onFinished) {
            currentExpectedResponse = ResponseKind.PROGRESS;
            let progress = -1; //start from -1 so when progress = 0 it will show up
            return msg => {
                window.console.log("Handling generation update: ", msg);
                state.commit("setLoadingStatus", msg.status);
                state.commit("setSeeds", msg.seeds);


                window.console.log("Setting progress:", msg.progress_human);
                state.commit("setLoadingProgress", `${msg.progress_human}%`);
                progress = msg.progress;
                if (msg.progress < progress)
                    window.console.warn("stale prog rcvd, old:", progress, " , new : ", msg.progress);

                onProgress(progress);
                if (! msg.finished)
                    return;

                currentExpectedResponse = null;
                onProgressUpdate = null;
                onFinished(msg);
            }
        }


        function generate(keywordsArray, state, router){

            const keywordsStr = keywordsArray.join(",");
            const data = {"keywords": keywordsStr,  ref: document.referrer };
            sendObj(RequestKind.GENERATE, data);
            onProgressUpdate = getProgressHandler(state, router, () => {}, msg => {
                const slug = msg.slug;
                window.console.log("Going to ", slug, msg);
                store.commit("setState", States.FETCHING); //ensure navigation won't be cancelled this time
                router.push({path: `/loading/${slug}`});
            })
        }

        /**
         * Since Regen is now started server side, this method is used to set the progress / finished message
         * handler once the server notifies us that regen has begun
         */
        function expectRegen(projectId, state, onProgress, onFinished) {
            onProgressUpdate = getProgressHandler(state, null,  onProgress, onFinished);
        }


        function fetchResults(payload)
        {
            return new Promise(function(resolve, reject) {
                window.console.log("Sending load results request", payload);

                sendObj( RequestKind.FILTER, payload);
                currentExpectedResponse = ResponseKind.RESULTS;
                onResultsReceived = msg => {
                    currentExpectedResponse = null;
                    //onResultsReceived = null;
                    resolve(msg);
                }
            });
        }


        function checkDomains(words) {
            const req = {
                words: words
            };
            window.console.log("Sending check domains msg:", req);
            sendObj( RequestKind.DOMAINS, req);
            currentExpectedResponse = ResponseKind.DOMAINS;
        }

        function vote(wordId, newVote)
        {
            return new Promise(function (resolve, reject) {
                const req = {
                    word_id: wordId,
                    new_vote: newVote
                };

                window.console.log("Sending vote request:", req);
                sendObj( RequestKind.VOTE, req);
                currentExpectedResponse = ResponseKind.VOTE;
                onVoteResult = msg => {
                    onVoteUpdate(msg);
                    //onVoteResult = null;
                    resolve(msg);
                }
            })
        }


        function markSeen(wordId) {
            const req = {word_id: wordId};
            window.console.debug("Sending 'mark seen' request", req);
            sendObj(RequestKind.MARK_SEEN, req);
        }

        function onMsg(m)
        {
            if (m.data === pong) {
                window.console.log("pong rcvd");
                return;
            }

            window.console.log("Received msg: ", m.data);

            const data = JSON.parse(m.data);

            switch (data.kind) {
                case ResponseKind.ERRORS:
                    handleErrors(data);
                    break;

                case ResponseKind.USER_DETAILS:
                    store.dispatch("identifyUser", data);
                    break;

                case ResponseKind.PROGRESS:
                    if ( currentExpectedResponse === ResponseKind.PROGRESS && onProgressUpdate != null)
                        onProgressUpdate(data);
                    else{
                        window.console.warn(`Unexpected progress, expected: ${currentExpectedResponse}, onUpdate:`, onProgressUpdate, data);
                        if (typeof onProgressUpdate === 'function')
                            onProgressUpdate(data);
                    }
                    break;

                case ResponseKind.RESULTS:
                    if ( currentExpectedResponse === ResponseKind.RESULTS && onResultsReceived != null)
                        onResultsReceived(data);
                    else {
                        window.console.warn(`Unexpected results, expected: ${currentExpectedResponse}, onResults:`, onResultsReceived, data);
                        if (onResultsReceived != null)
                            onResultsReceived(data)
                    }
                    break;


                case ResponseKind.DOMAINS:
                    if ( currentExpectedResponse === ResponseKind.DOMAINS)
                        onDomainsUpdate(data);
                    else {
                        window.console.warn(`Received domains unexpected but handling, expected: ${currentExpectedResponse}`, data);
                        onDomainsUpdate(data);
                    }
                    break;

                case ResponseKind.VOTE:
                    if ( currentExpectedResponse === ResponseKind.VOTE)
                        //onVoteUpdate(data);
                        onVoteResult(data);
                    else {
                        window.console.warn(`Unexpected vote result, expected: ${currentExpectedResponse}`, data);
                        if (typeof onVoteResult=== 'function')
                            onVoteResult(data)
                    }
                    break;


                case ResponseKind.PRE_PURCHASE_INFO:
                    if (typeof currentPrePurchaseHandler === 'function')
                        currentPrePurchaseHandler(data);
                    else
                        window.console.warn("Received PRE_PURCHASE_INFO but current handler is not a func", data, currentPrePurchaseHandler );
                    break;

                case ResponseKind.PAYMENT_INTENT:
                    if (typeof currentIntentHandler === 'function')
                        currentIntentHandler(data);
                    else
                        window.console.warn("Received PAYMENT_INTENT but current handler is not a func", data, currentIntentHandler );
                    break;

                case ResponseKind.PREPARE_FOR_MONEY:
                    if (typeof currentPrepareForMoneyHandler === 'function')
                        currentPrepareForMoneyHandler(data);
                    else
                        window.console.warn("Received PREPARE_FOR_MONEY but current handler is not a func", data, currentPrepareForMoneyHandler );
                    break;

                case ResponseKind.TXN_STATUS:
                    if (typeof currentTxnStatusHandler === 'function')
                        currentTxnStatusHandler(data);
                    else
                        window.console.warn("Received TXN_STATUS but current handler is not a func", data, currentTxnStatusHandler );
                    break;

                default:
                    window.console.warn(`Ignoring unknown response, kind: ${data.kind},`, data);
                    break;
            }
        }

        function onClose(m) {
            window.console.warn("closed: ", m);

            resetCallbacks();
            store.commit("setError", "Connection to the server lost. Please refresh this page, or reach out to" +
                        " us at hi@naminus.com");
        }

        function resetCallbacks() {
            currentExpectedResponse = null;
            onProgressUpdate = null;
            onResultsReceived = null;
        }

        function sendPing() {
            if (that.socket.readyState === WebSocket.CONNECTING) {
                setTimeout(sendPing, 1000);
                return;
            }

            if (that.socket.readyState === WebSocket.OPEN) {
                //window.console.log("Sending ping");
                sendString(ping);
                setTimeout(sendPing, 5000);
            }
            else
                window.console.warn("Socket not open - not sending ping: " + that.socket.readyState)
        }

        function sendString(str) {
            window.console.debug("Sending str: ", str);
            that.socket.send(str);
        }

        function sendObj(kind, obj)
        {
            const finalObj = {
              kind: kind,
              data: obj
            };

            window.console.log("Sending: ", finalObj);
            const str = JSON.stringify(finalObj);
            sendString(str);
        }

        function handleErrors(data) {
            window.console.warn("Received error from server:", data.errors);
            store.commit("setError", data.errors[0]); //usually just 1 error is sent
            if (data.redirect)
                router.push({path: "/"});
        }

        function onDomainsUpdate(data) {
            window.console.log("Received domain availability:", data);
            currentExpectedResponse = null;

            data.words.forEach(item => {
                store.commit("setDomainStatus", item);
            });
        }

        function onVoteUpdate(data)
        {
            window.console.log("Received word vote result:", data);
            currentExpectedResponse = null;
            const deets = {
                id: data.word_id,
                newVote: data.new_vote
            };

            store.commit("setWordVote", deets);

        }

        function prePurchaseInfo()
        {
            return new Promise(function(resolve, reject) {
                window.console.log("Sending pre-purchase info");

                sendObj( RequestKind.PRE_PURCHASE_INFO, {});
                currentExpectedResponse = ResponseKind.PRE_PURCHASE_INFO;
                currentPrePurchaseHandler = msg => {
                    window.console.log("Got pre-purchase info response", msg);
                    currentPrePurchaseHandler = null;
                    resolve(msg);
                }
            });
        }


        function reqPaymentIntent(payload)
        {
            return new Promise(function(resolve, reject) {
                window.console.log("Sending request payment intent request", payload);

                sendObj( RequestKind.PAYMENT_INTENT, payload);
                currentExpectedResponse = ResponseKind.PAYMENT_INTENT;
                currentIntentHandler = msg => {
                    window.console.log("Got payment intent response", msg);
                    currentIntentHandler = null;
                    resolve(msg);
                }
            });
        }


        function prepareForMoney(payload)
        {
            return new Promise(function(resolve, reject) {
                window.console.log("Sending prepare 4 money", payload);

                sendObj( RequestKind.PREPARE_FOR_MONEY, payload);
                currentExpectedResponse = ResponseKind.PREPARE_FOR_MONEY;
                currentPrepareForMoneyHandler = msg => {
                    window.console.log("Got prepare for money response", msg);
                    currentPrepareForMoneyHandler = null;
                    resolve(msg);
                }
            });
        }

        function txnStatus(payload) {
            return new Promise(function(resolve, reject) {
                window.console.log("Sending txn status req", payload);

                sendObj( RequestKind.TXN_STATUS, payload);
                currentExpectedResponse = ResponseKind.TXN_STATUS;
                currentTxnStatusHandler = msg => {
                    window.console.log("Got txn status response", msg);
                    currentTxnStatusHandler = null;
                    resolve(msg);
                }
            });
        }
    }

}
